module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.reservation.billing) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("\n                VAT Number\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.billing.details.vat),
      expression: "reservation.billing.details.vat"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text",
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": (_vm.reservation.billing.details.vat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.billing.details, "vat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("\n                City\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.billing.details.city),
      expression: "reservation.billing.details.city"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text",
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": (_vm.reservation.billing.details.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.billing.details, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("\n                Country\n            ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getCountries,
      "label": "name",
      "disabled": _vm.readOnly
    },
    on: {
      "input": _vm.selectedCountryChanged
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("\n                Billing name\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.billing.details.businessName),
      expression: "reservation.billing.details.businessName"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text",
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": (_vm.reservation.billing.details.businessName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.billing.details, "businessName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("\n                Address\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.billing.details.address),
      expression: "reservation.billing.details.address"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text",
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": (_vm.reservation.billing.details.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.billing.details, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.compShowInvoiceBtn) ? _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer",
    class: {
      'opacity-50 notAllowed': _vm.unsavedChanges
    },
    attrs: {
      "disabled": _vm.isSavingReservation || _vm.getIsCreatingInvoice
    },
    on: {
      "click": _vm.startCreateInvoice
    }
  }, [_vm._v(_vm._s(_vm.getIsCreatingInvoice ? 'Invoicing...' : 'Invoice'))]) : _vm._e()])]) : _c('div', {
    staticClass: "dark text-center m-5 w-100"
  }, [_c('div', {
    staticClass: "fs-large darker"
  }, [_vm._v("Unable to load information")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-cdd1bc1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdd1bc1c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Details/BillingDetails.vue
// module id = 1192
// module chunks = 0